import { Page } from '../../../../../components/page/page';
import { DeleteModal } from '../../../../../features/delete-modal/delete-modal';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { RestoreModal } from '../../../../../features/restore-modal/restore-modal';
import { QrCodeModal } from '../../qrs/list/qr-code-modal/qr-code-modal';
import s from './device-qr-list.module.css';
import { DevicesQrCards } from './devices-qr-cards/devices-qr-cards';
import { DevicesQrControls } from './devices-qr-controls/devices-qr-controls';
import { DevicesQrTable } from './devices-qr-table/devices-qr-table';
import { useDeviceQrList } from './use-device-qr-list';

export const DeviceQrList = () => {
  const { dynamicList, viewDynamicQrModal, t, restoreQrCode, deleteQrCode, viewStyle } =
    useDeviceQrList();

  return (
    <Page className={s.page}>
      <h2 className={s.title}>
        {t('Устройства')} ({dynamicList?.length})
        <DevicesQrControls />
      </h2>

      {viewStyle === 'table' ? <DevicesQrTable /> : <DevicesQrCards />}

      <HasAccess service="device" permissions={['write']}>
        <RestoreModal onSubmit={(id) => restoreQrCode(id, 'AUTH_COMMON_DYNAMIC')} />
        <DeleteModal onSubmit={(id) => deleteQrCode(id, 'AUTH_COMMON_DYNAMIC')} />
      </HasAccess>

      {viewDynamicQrModal.isOpen && (
        <QrCodeModal
          onClose={() =>
            viewDynamicQrModal.handleCloseModal(['qrId', 'qrName', 'code', 'isAttached'])
          }
        />
      )}
    </Page>
  );
};
